import styled from 'styled-components';
import { StyledContainer } from './StyledContainer';

export const Nav = styled(StyledContainer).attrs(() => ({ as: 'nav' }))``;
export const Header = styled(StyledContainer).attrs(() => ({ as: 'header' }))``;
export const Footer = styled(StyledContainer).attrs(() => ({ as: 'footer' }))``;
